export default __webpack_public_path__ + "static/media/X.2692eb6b.svg";